export var Global = (function() {
  let instance;

  function init() {
    return {
      modules: {},
      callbacks: {},
      callbackId: '0'
    };
  }
  return {
    getInstance: function() {
      if (!instance) {
        instance = init();
      }
      return instance;
    }
  };
})();


// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/fusion/src/core/global.js